<template>
    <div class="products_list">
        <div class="container">
            <breadcrumbs :dom="crumbsItem" />
            <div class="products collection">
                <ProductItemBox :noProduct="noProduct" :products="products" :products_title="classificationName" />
            </div>
            <loadmore v-if="!lastPage" @loadMore="loadMore" />
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import ProductItemBox from '@/components/products/items/ItemBox'
    import Loadmore from '@/components/partial/Loadmore'
    import classApi from '@/api/class'
    import typeDefApi from "@/api/typeDef";
    import advancedSearchMixin from '@/mixins/advancedSearch'
    import classificationsMixin from '@/mixins/classifications'
    import userMixin from '@/mixins/user'

    export default {
        mixins: [
            classificationsMixin,
            advancedSearchMixin,
            userMixin,
        ],
        props: {
            id: String, // 取自router :id名稱
            filterConditionID: {
                type: Number,
                default () {
                    return 1;
                },
            }
        },
        components: {
            Breadcrumbs,
            ProductItemBox,
            Loadmore,
        },
        computed: {
            classificationName() {
                let name = this.id;

                if (this.filterConditionID == 1) {
                    name = this.getClassificationNameById(this.id);
                }

                return name ? name : '';
            },
            crumbsItem() {
                return [{
                        text: '首頁',
                        to: {
                            name: 'home'
                        },
                    },
                    {
                        text: this.classificationName,
                        active: true
                    },
                ];
            }
        },
        created() {
            this.loadMore();
        },
        mounted() {
          if (this.id !== '熱門區' && this.id !== '預告區' && this.id !== '新上架') {
            this.queryMetaInfo();
          }
        },
        destroyed() {
          const metaTags = document.querySelectorAll('meta[property^="og:"]');
          metaTags.forEach((metaTag) => {
            metaTag.parentNode.removeChild(metaTag);
          });
        },
      data() {
            return {
                products: [],
                currentPage: 1,
                perPage: 20,
                lastPage: false,
                noProduct: false
            }
        },
        watch: {
            id() {
                this.reset();
            },
        },
        methods: {
            initUser() {
                this.reset();
            },
            initAdvancedSearch() {
                this.reset();
            },
            reset() {
                this.products = [];
                this.lastPage = false;
                this.currentPage = 1;
                this.loadMore();
            },
            loadMore() {
                let filter = {
                    FilterConditionID: this.filterConditionID,
                    TypeID: this.id,
                    CurrentPage: this.currentPage,
                    PerPage: this.perPage
                };

                classApi.queryList(filter, (data) => {
                    data = data ? data : [];
                    this.products = this.products.concat(data);
                    this.noProduct = this.products.length === 0;

                    if (data.length < this.perPage) {
                        this.lastPage = true;
                    }

                    this.currentPage++
                });
            },
            queryMetaInfo() {
                typeDefApi.queryMetaInfo(this.id, (data) => {

                // Create new meta tags
                if (data.metaImageUrl) {
                    const metaImage = document.createElement('meta');
                    metaImage.setAttribute('property', 'og:image');
                    metaImage.setAttribute('content', data.metaImageUrl);
                    document  .head.appendChild(metaImage);
                }

                if (data.metaTitle) {
                    const metaTitle = document.createElement('meta');
                    metaTitle.setAttribute('property', 'og:title');
                    metaTitle.setAttribute('content', data.metaTitle + ' | 特力屋手創空間');
                    document.head.appendChild(metaTitle);
                }

                if (data.metaDesc) {
                    const metaDescription = document.createElement('meta');
                    metaDescription.setAttribute('property', 'og:description');
                    metaDescription.setAttribute('content', data.metaDesc);
                    document.head.appendChild(metaDescription);
                }
                });
            }
        },
    }
</script>
